import { Component, OnInit, Input, Output, ViewChild, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormElementComponent } from '../form-element/form-element.component';
import { EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectInputComponent } from '../select-input/select-input.component';
import { debounceTime, distinctUntilChanged, map, startWith, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, combineLatest, of, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { StringFilterByPipe } from 'src/app/shared/pipes/string-filter-by-pipe.pipe';
//!RESOLVER: Se selecciona el primer valor de la lista al buscar por el filter y cuando lo selecciono no se llama al onchange
@Component({
    selector: 'app-select-searching-input',
    templateUrl: './select-searching-input.component.html',
    styleUrls: ['./select-searching-input.component.scss']
})
export class SelectSearchingInputComponent extends FormElementComponent
    implements OnInit {
    @ViewChild('singleSelect', { static: true }) singleSelect!: MatSelect;
    private _elements: any[] = [];
    private elements$ = new BehaviorSubject<any[]>([]);
    @Input() set elements(val: any[]) {
        this._elements = Array.isArray(val) ? val : [];
        this.elements$.next(this._elements);
    }
    get elements(): any[] { return this._elements; }
    @Input() noOptionText!: string;
    @Input() nameSearching!: string;
    @Input() placeholderNoValue!: string;
    @Input() placeholderSearching!: string;
    @Input() defaultValue!: any;
    // Forwarded tooltip text from parent. Using the same name allows existing templates
    // that bind [matTooltip] on <app-select-searching-input> to keep working.
    @Input() matTooltip: string | null = null;
    @Input() inputBgColor: string | null = null;
    @Input() inputTextColor: string | null = null;
    // Input provided that indicates if the values of the mat-options will be computed as strings or numbers
    @Input() forceNumber!: string;
    // Optional function to determine if an option should be disabled
    @Input() isOptionDisabled?: (id: any) => boolean;
    // Functions provided by the parent that tells the component how to calculate the id and name of the options
    @Input() calculateId: (element:any) => any = (e) => e.id;
    @Input() calculateName: (element:any) => any = (e) => e.name;
    // Emit an event every time the select changes
    @Output() public selected: EventEmitter<any> = new EventEmitter();
    /** Subject that emits when the component has been destroyed. */
    /** list of banks filtered by search keyword */
    searchPipe = new StringFilterByPipe();
    searchingSpinner = false;
    public filteredValues!: Observable<any>;
    protected _onDestroy = new Subject<void>();
    get searchCtrl(): FormControl {
        return this.form.get(this.nameSearching) as FormControl;
    }
    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    private applyDefaultValue(): void {
        if (this.defaultValue === undefined || this.defaultValue === null || this.defaultValue === '') {
            return;
        }
        const value = this.forceNumber ? Number(this.defaultValue) : this.defaultValue;
        this.form.get(this.name)?.setValue(value);
    }

    // Static function that returns the appropriate function according to the "calculate" parameter
    static proxyCalculate(calculate:any): (element:any) => string {
        if (typeof calculate === 'string') {
            return element => {
                return element ? element[String(calculate)] : null;
            };
        } else {
            return calculate;
        }
    }

    // Proxy that calls the proxyCalculate function with a function or string that tells this component how to calculate the Id
    proxyCalculateId(): (element:string) => string {
        return SelectInputComponent.proxyCalculate(this.calculateId);
    }

    // Proxy that calls the proxyCalculate function with a function or string that tells this component how to calculate the Name
    proxyCalculateName(): (element:string) => string {
        return SelectInputComponent.proxyCalculate(this.calculateName);
    }

    override ngOnInit() {
        if (this.forceNumber) {
            // Subscribe at any change in the select form control and everytime a new option is
            // selected, convert the value to Number if it isn't
            this.form.get(this.name)?.valueChanges.subscribe(value => {
                if (typeof value === 'string') {
                    this.form.get(this.name)?.setValue(Number(value));
                }
            });
        }

        this.applyDefaultValue();

        if (!this.form.contains(this.nameSearching)) {
            this.form.addControl(this.nameSearching, new FormControl(''));
        }

        const search$ = this.searchCtrl?.valueChanges.pipe(
            startWith(''),
            debounceTime(150),
            distinctUntilChanged(),
            map((v: string) => (v ?? '').toLowerCase().trim()),
            tap(() => this.searchingSpinner = true)
        ) || of('');

        this.filteredValues = combineLatest([this.elements$, search$]).pipe(
            map(([elems, term]) => {
                const base = elems ?? [];
                if (!term) {
                    return base.slice();
                }
                return this.searchPipe.transform(base, term, this.proxyCalculateName());
            }),
            tap(() => this.searchingSpinner = false)
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['defaultValue']) {
            this.applyDefaultValue();
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    calculateSelected(id: any) {
        let elementSelected = null;
        if (this.elements) {
            elementSelected = this.elements.find(
                element =>
                    this.proxyCalculateId()(element) ===
                    (this.forceNumber ? Number(id) : id)
            );
        }
        return elementSelected;
    }

    change(event: any) {
        // Called everytime a new value is selected
        this.selected.emit(event.value);
    }

    getError() {
        const control = this.form.get(this.name);
        if (control && control.errors) {
          return this.objectValues(control.errors)[0];
        }
        return null;
      }
}
